// extracted by mini-css-extract-plugin
module.exports = {"root":"Button_root__1fcD1","secondary":"Button_secondary__1sG9u","special":"Button_special__1kWxv","ghost":"Button_ghost__1FHE2"};